import React from "react";
import SiteLink from "../Shared/SiteLink";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const MapPopup = ({ site }) => {
  const toNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };
  const outputKw =
    toNumber(site.solar_capacity) +
    toNumber(site.battery_capacity) +
    toNumber(site.genset_capacity);
  const hasStorage =
    site.battery_energy_capacity !== null && site.battery_energy_capacity !== undefined;
  const storageKwh = hasStorage ? toNumber(site.battery_energy_capacity) : null;
  return (
    <Box className="map-popover">
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <SiteLink site={site} />
      </Box>
      <Typography variant="caption" display="block">
        Site Output Capacity / Site Storage Capacity:{" "}
        {outputKw.toLocaleString()} kW /{" "}
        {hasStorage ? `${storageKwh.toLocaleString()} kWh` : "-"}
      </Typography>
      {site.status ? <Typography variant="caption">{site.status}</Typography> : null}
    </Box>
  );
};

MapPopup.propTypes = {
  site: PropTypes.object,
};

export default MapPopup;
